
  import { Component, Vue ,Inject } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Switch from '@/components/switch.vue';
	import UploadImg from '@/components/upload-img.vue';
	import ChoosePages from '@/components/choosepages/choosepages.vue';
  import previewImg from "@/components/previewImg.vue"
  import {
    productpopoverproductlist
  } from '@/api/supplier'
  import {
    imgHost
  } from "@/utils/config"
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-switch': Switch,
      UploadImg,
      ChoosePages,
      previewImg
    }
  })

  export default class ProductList extends Vue {
    private token:any = {}

    private show = false
    private choosemsg:any = {}
    private exampleShow = false
    private currentUrl = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/2353402c1518331a4b47d1d23c9f045.png'
    
    @Inject() information:any
    get value(){
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      if(this.editinfo.msg.link.pagetype==2){
        this.gettablelist()
      }else{
        this.editinfo.msg.shoplist = []
      }
      return this.editinfo.msg
    }


    private getdata(e){
      this.editinfo.msg.link = e
      // console.log(e)
      // if(e.pagetype==2){
      //   this.gettablelist()
      // }else{
      //   this.editinfo.msg.shoplist = []
      // }
      this.show = false
    }
    private getImageInfo(url){
      return new Promise((resolve, reject)=>{
        let imageUrl = imgHost + url;
        let image = new Image();
        image.onload = function(){
          resolve({
            width: image.width,
            height: image.height
          });
        }
        image.onerror = function(){
          resolve({
            width: 0,
            height: 0
          });
        }
        image.src = imageUrl;
      })
    }
    private async uploadSuc(e,key){
      let imageInfo:any = await this.getImageInfo(e[0]);
      this.editinfo.msg[key] = e[0]
      this.editinfo.msg[key+'Width'] = imageInfo.width;
      this.editinfo.msg[key+'Height'] = imageInfo.height;
    }
    private clear(){
      this.editinfo.msg.link = {}
    }
    private choosepage(){
      this.choosemsg = this.editmsg.link
      this.show = true
    }
    //商品列表
    private async gettablelist(){
      try{
        let data:any = {
					Skip: 0,
					Take: 3,
					Keywords: '',
					ProductCategoryId: this.editinfo.msg.link.Id,
          // IsIncludeFinished:false,
          IsOpen:true,
          OrderBy:'Sort',
          IsAsc:false,
				}
        let res = await productpopoverproductlist(data)
        if(res.IsSuccess){
          this.editinfo.msg.shoplist = res.Result.Results.map(v=>v.ImgUrlComplete)
          // console.log(this.editinfo.msg.shoplist)
        }
      }finally{
        //
      }
    }
  }
